<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx">
            変更したいメールアドレスをご入力ください。<br class="_dsp-none--sp">
            その後確認用のメールを送付いたしますので、そちらに<br class="_dsp-none--sp">記載の確認用URLをクリックしてください。
          </p>
          <div :class="`Form__input_box Form__input_box--xlg ${($v.userInfo.email.$error || errors.email) ? '_error' : ''}`">
            <input
              v-model.trim="$v.userInfo.email.$model"
              class="Form__input Form__input--mt_md"
              type="email"
              placeholder="sample@gmail.com"
              @click="checkMail = false"
            >
            <div class="Form__error_box">
              <div class="Form__error_tx">
                <label v-if="!$v.userInfo.email.required" class="Form__error_tx">正しいメールアドレスを入力してください。</label>
                <label v-if="!$v.userInfo.email.email" class="Form__error_tx">正しいメールアドレスを入力してください。</label>
                <label v-if="!$v.userInfo.email.maxLength" class="Form__error_tx">メールの最大長254</label><br>
                <label v-if="errors.email && checkMail" class="Form__error_tx">{{ errors.email }}</label>
              </div>
            </div>
          </div>
          <button
            :disabled="$v.userInfo.$invalid"
            class="Btn__blue Form__btn--mt_md"
            @click="updateUserEmail()"
          >
            確認用メールを送信
          </button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { redirect } from '@/helpers'

const validations = {
  userInfo: {
    email: {
      required,
      email,
      maxLength: maxLength(254)
    }
  }
}
export default {
  name: 'ChangeMail',
  mixins: [validationMixin],
  data() {
    return {
      userInfo: {
        email: ''
      },
      errors: {
        email: ''
      },
      isLoading: false,
      showError: false,
      isError: false,
      checkMail: false
    }
  },
  methods: {
    async updateUserEmail() {
      this.$v.userInfo.$touch()
      if (this.$v.userInfo.$invalid) {
        return
      }
      this.$store.dispatch('loading/updateLoading', true)
      authService.checkUpdateEmail(this.userInfo)
        .then((response) => {
          const redirectPath = '/change/mail/send'
          authService.updateUserEmail(this.userInfo)
          this.isLoading = false
          this.$store.dispatch('loading/updateLoading', false)
          redirect(redirectPath)
        })
        .catch((error) => {
          this.$store.dispatch('loading/updateLoading', false)
          this.errors.email = error.data.message
          this.isError = true
          this.checkMail = true
        })
    },
    async checkUpdateEmail() {
      if (this.userInfo.email && !this.$v.userInfo.email.$invalid) {
        this.$store.dispatch('loading/updateLoading', true)
        authService.checkUpdateEmail(this.userInfo)
          .then((response) => {
            this.errors.email = ''
            this.isError = false
            this.$store.dispatch('loading/updateLoading', false)
          })
          .catch((error) => {
            this.errors.email = error.data.message
            this.isError = true
            this.checkMail = true
            this.$store.dispatch('loading/updateLoading', false)
          })
      } else {
        this.errors.email = ''
      }
    }
  },
  validations: validations
}
</script>
